import attempt from 'lodash/attempt';
import isError from 'lodash/isError';
import axios from 'axios';
import qz from 'qz-tray';
import Cookies from 'js-cookie';
import { parseISO, isValid } from 'date-fns';
import * as yup from 'yup';
import { toZonedTime as toZonedTime$1, fromZonedTime as fromZonedTime$1 } from 'date-fns-tz';

function sum(...args) {
    return args.reduce((acc, val)=>acc + val, 0);
}
function test() {
    return 'test';
}

function validateRichText(value) {
    return hasRichTextContent(value);
}
function hasRichTextContent(value) {
    const parsed = parseAsRichText(value);
    return !!(parsed == null ? void 0 : parsed.some((item)=>{
        // video and image types are considered "content"
        if (item.type === "video" || item.type === "image") return true;
        // for the remainder, check deeper into the children prop for text content
        return item.children.some((c)=>c.text || c.url || c.content);
    }));
}
function isRichTextOnlyParagraphs(value) {
    const parsed = parseAsRichText(value);
    return !!(parsed == null ? void 0 : parsed.every((item)=>item.type === "paragraph" && item.children.every((c)=>c.text)));
}
function isValidRichTextFormat(value) {
    const parsed = parseAsRichText(value);
    return !!(parsed == null ? void 0 : parsed.some((item)=>{
        return item.children.some((c)=>c.text !== undefined || c.url !== undefined);
    }));
}
function parseAsRichText(value) {
    const parsedContent = attempt(JSON.parse, value);
    return !parsedContent || isError(parsedContent) ? undefined : parsedContent;
}
function convertToRichText(input) {
    const asRichText = {
        type: "paragraph",
        children: [
            {
                text: input != null ? input : ""
            }
        ]
    };
    return JSON.stringify([
        asRichText
    ]);
}
function ensureRichTextFormat(input) {
    if (isValidRichTextFormat(input)) {
        return input;
    }
    if (typeof input !== "string") return convertToRichText("");
    return convertToRichText(input);
}
function convertToPlainText(input) {
    if (!input) return "";
    if (!isValidRichTextFormat(input)) return input;
    const parsed = parseAsRichText(input);
    if (!parsed) return "";
    function mapItem(item) {
        return item.children.map((child)=>{
            if (child.children && child.type !== "link") {
                return mapItem(child);
            }
            return child.content || child.text;
        }).join(item.type.includes("list") ? "\n" : " ");
    }
    return parsed.map(mapItem).join("\n\n");
}
function ensurePlainTextFormat(input) {
    return convertToPlainText(input);
}

function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

const CERT = `-----BEGIN CERTIFICATE-----
MIIFHDCCAwSgAwIBAgIQNzkyMDI1MDUxMjIzNDAwOTANBgkqhkiG9w0BAQsFADCB
mDELMAkGA1UEBhMCVVMxCzAJBgNVBAgMAk5ZMRswGQYDVQQKDBJRWiBJbmR1c3Ry
aWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcGA1UEAwwQ
cXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBxemluZHVz
dHJpZXMuY29tMB4XDTI1MDUxMjIzNDAwOVoXDTI2MDUxOTAyMjIzNFowgdcxCzAJ
BgNVBAYMAk5aMREwDwYDVQQIDAhBdWNrbGFuZDERMA8GA1UEBwwIQXVja2xhbmQx
FDASBgNVBAoMC0ZsaWNrZXQgTHRkMRQwEgYDVQQLDAtGbGlja2V0IEx0ZDEUMBIG
A1UEAwwLRmxpY2tldCBMdGQxIjAgBgkqhkiG9w0BCQEME2ppbW15QGZsaWNrZXQu
Y28ubnoxPDA6BgNVBA0MM3JlbmV3YWwtb2YtOTdhMmIzNDk1ZDczY2ZlODY2YTdk
M2RjNDU1MDc3MzVlNmUzN2I1MjCCASAwCwYJKoZIhvcNAQEBA4IBDwAwggEKAoIB
AQCxxIZt47Foe2BABvF4GLRDM5BGURFF+NHIlMkDMGvHSargzFN3W8GsY7Oz2Amc
ZqGhkxySPQZy2T4QJIvkZvx5BE4V65yao9ZJJzRjqTyXxe1fdfkNU72SshxGgiVv
eyMGzdoi8sJ9ETP8plmcMM7jwq33kSHPwDCD6QDHIt+9mvVAxmyCr5EjOTyRbtHc
dwgGIYROOpB6XKsVImek69nabXglhCfjzTdBoQus+5RL9PXjs+VFGT/J6IY4byVL
i+Z9sUy91EAicK7i6yr3yg7AGgrIivza0E8US4Wi0D5MKhwP18jVtWLINV7XSzmF
7C16hEglxaQn1epKviPmufOfAgMBAAGjIzAhMB8GA1UdIwQYMBaAFJCmULeE1Lnq
X/IFhBN4ReipdVRcMA0GCSqGSIb3DQEBCwUAA4ICAQBo51fvE+fa7yj4IO96D1FA
k84RjGwgATOZ5XD0RSKP5aT2Kuzdy5t8jbRJ4JYHnn+9KWq4Ajq5zUwAs/Ec4EdR
OMNpXGZMTY5euye2W8nKe0B5U44rDz2y+q/XqD6zNRfbqYL/ooRE8+9eSQklYEX4
JJ2VYwQ2OEroGV13vKsXOGerXK2B38D1hhn81e66A915ieUi97jvSaa5/dVdewqM
UYG+w390UuBtVvEgWAA6uV0BehSCB7J6rJGVMMbDoR8uEGbmL9w8174Z8JQq0Jh6
h+SQLAGgmuQLGxtX+1ZXByQjJ2/n2Y7+7USw7acSlACuLefmIiV5Un91Jk2finlm
HRQd+d2OjQB5KzBLQ0LWjOtFLDaZI/0uGg6GJiEB+fdHr5aBcyvba46iSCMcsxUp
wKvtslCCmGVqALEPHSLEFKxNs/qOXJLHxLDLjjKZrcahMH1l7QdB98S1DUwTbP3a
ppTFfbaOE4QPtu4mxSUxz8PnC42Om11DnJkLt4FcGZuY2JDJd+SaWfSBsP2A8Oit
ZfcuPiyBEslz2YpL5WwLXnLER97yAzfZoUk/vPpAALbhSPhGj13t2N0QhulgKyAC
kyDdWhn+Wr4GWVKjiXd9js0s8G/aPzKWdEyxumGEXi5yTYUavEHJLNLh2vxnKxR8
0uUYPez6zUHcU+UapjTYxQ==
-----END CERTIFICATE-----
--START INTERMEDIATE CERT--
-----BEGIN CERTIFICATE-----
MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT
MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ
bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG
A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx
emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow
gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0
cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM
EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1
c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU
iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H
YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM
GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH
EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh
0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX
xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1
9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE
ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD
2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX
6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY
5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ
plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S
BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ
eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k
gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT
x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu
pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw
2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp
rbO7BnjW
-----END CERTIFICATE-----`;

function arrayConstToMap(arr) {
    return Object.freeze(arr.reduce((acc, p)=>{
        acc[p] = p;
        return acc;
    }, {}));
}

axios.defaults.withCredentials = true;
const PRINTER_CONFIG_PREFIX = "printer-config-";
const PRINTER_LANGUAGES = [
    "escpos",
    "zpl"
];
const PRINTER_LANGUAGES_MAP = arrayConstToMap(PRINTER_LANGUAGES);
const PRINTERS = [
    "honeywell",
    "intermec",
    "epson",
    "slk"
];
const PRINTERS_MAP = arrayConstToMap(PRINTERS);
const printerConfigDefault = {
    labelShift: 0,
    labelTop: 0
};
/**
 * Connects to QZ Tray and sends print jobs to known printers.
 * 
 * 
 */ class Printer {
    /**
   * Attempt to connect to QZ Tray.
   */ async connectToSoftware() {
        if (this.isConnected) {
            return true;
        }
        console.log("Connecting to QZ Tray printer software...");
        try {
            qz.security.setCertificatePromise((resolve)=>{
                resolve(CERT);
            });
            await qz.websocket.connect({
                retries: 1,
                delay: 1
            });
            return true;
        } catch (e) {
            console.log("Unable to connect to QZ Tray printer software.");
        }
        return false;
    }
    /**
   * Return true if currently connected to QZ Tray.
   */ get isConnected() {
        return qz.websocket.isActive();
    }
    /**
   * Disconnect from QZ Tray.
   */ async disconnectPrinterSoftware() {
        if (!this.isConnected) {
            return false;
        }
        console.log("Disconnecting from QZ Tray printer software...");
        try {
            await qz.websocket.disconnect();
            return true;
        } catch (e) {
            console.log("Unable to disconnect from QZ Tray printer software.");
        }
        return false;
    }
    setPrinterConfig(userOptions = {}, orgId) {
        const tld = location.hostname.includes("localhost") ? location.hostname : location.hostname.replace("admin.", "");
        const cookieDomain = tld.startsWith(".") ? tld : `.${tld}`;
        const { labelShift, labelTop } = userOptions, remainingOptions = _object_without_properties_loose(userOptions, [
            "labelShift",
            "labelTop"
        ]);
        const options = JSON.stringify(_extends({}, remainingOptions, {
            // parseInt will return NaN if not able to parse, this will then result in
            // in the false condition of the ternary, or it will be coerced into a number via `+`
            labelShift: parseInt(labelShift) ? +labelShift : printerConfigDefault.labelShift,
            labelTop: parseInt(labelTop) ? +labelTop : printerConfigDefault.labelTop
        }));
        const key = this.getPrinterConfigKey(orgId);
        Cookies.set(key, options, {
            domain: cookieDomain
        });
    }
    getPrinterConfig(orgId) {
        try {
            const key = this.getPrinterConfigKey(orgId);
            const cookieResult = Cookies.get(key);
            return cookieResult ? JSON.parse(cookieResult) : printerConfigDefault;
        } catch (error) {
            // If anything goes bad, return defaults
            return printerConfigDefault;
        }
    }
    async printHardcopyTickets(options) {
        const printerName = await this.findActivePrinterName(options.organizationId);
        const printerConfig = this.getPrinterConfig(options.organizationId);
        const { data } = await axios.get(`${this.url}/ticket/hardcopy`, {
            params: _extends({
                "flicket-org-id": options.organizationId,
                orderId: options.orderId
            }, options.ticketIds && {
                ticketIds: options.ticketIds
            }, {
                format: this.getPrinterLanguage(printerName),
                preprint: options.markAsPreprint ? "true" : null,
                membership: options.isMembership ? true : null
            }, options.receipt && {
                receipt: 1
            })
        });
        await this.doPrint(printerName, data, printerConfig);
    }
    async printOrderReceipt(options) {
        const printerName = await this.findActivePrinterName(options.organizationId);
        const printerConfig = this.getPrinterConfig(options.organizationId);
        const { data } = await axios.get(`${this.url}/ticket/hardcopy`, {
            params: _extends({
                "flicket-org-id": options.organizationId,
                orderId: options.orderId
            }, options.ticketIds && {
                ticketIds: options.ticketIds
            }, {
                format: this.getPrinterLanguage(printerName),
                preprint: options.markAsPreprint ? "true" : null,
                membership: options.isMembership ? true : null,
                receiptOnly: 1
            })
        });
        await this.doPrint(printerName, data, printerConfig);
    }
    getPrinterLanguage(printerName) {
        if ((printerName == null ? void 0 : printerName.toLowerCase().includes(PRINTERS_MAP.epson)) || (printerName == null ? void 0 : printerName.toLowerCase().includes(PRINTERS_MAP.slk))) {
            return PRINTER_LANGUAGES_MAP.escpos;
        }
        return PRINTER_LANGUAGES_MAP.zpl;
    }
    /**
   * Send a print job to QZ Tray.
   * Automatically connects if not connected.
   */ async doPrint(printerName, printerCommands, printerConfig) {
        if (!printerCommands) {
            throw "No data to print.";
        }
        const config = qz.configs.create(printerName);
        if (this.getPrinterLanguage(printerName) === PRINTER_LANGUAGES_MAP.escpos) {
            await qz.print(config, [
                {
                    type: "raw",
                    format: "command",
                    flavor: "base64",
                    data: printerCommands
                }
            ]);
            return;
        }
        const { labelShift, labelTop } = printerConfig;
        printerCommands = printerCommands.replace(/\^XA/gm, `^XA^LS${labelShift}^LT${labelTop}`);
        // Adjust alignment on Honeywell printers
        if (printerName.toLowerCase().includes(PRINTERS_MAP.honeywell)) {
            printerCommands = printerCommands.replace("^XA", `
          ^XA
          ^LH0,0
          ^MNN
          ^LL1120
          ^PW575
        `);
            // Replace if no labelTop set in config
            printerCommands = printerCommands.replace("^LT0", "^LT-100");
        }
        await qz.print(config, [
            printerCommands
        ]);
    }
    async findActivePrinterName(organizationId) {
        if (!await this.connectToSoftware()) {
            throw "No connection to QZ Tray.";
        }
        await qz.security.setSignaturePromise((toSign)=>async (resolve)=>{
                try {
                    const res = await axios.post(`${this.url}/ticket/printing/sign`, {
                        message: toSign
                    }, {
                        params: {
                            "flicket-org-id": organizationId
                        }
                    });
                    resolve(res.data.signature);
                } catch (e) {
                    resolve();
                }
            });
        let printerName = null;
        // You can set a development printer name in the environment variables
        // https://github.com/rodyager/RWTS-PDFwriter if you want to test without a printer on MacOs
        if (process.env["DEVELOPMENT_PRINTER_NAME"] !== undefined) {
            console.log("Using development printer: ", process.env["DEVELOPMENT_PRINTER_NAME"]);
            return process.env["DEVELOPMENT_PRINTER_NAME"];
        }
        if (qz.api.isVersionGreater(2, 2, 0)) {
            printerName = await this.findPluggedInPrinter();
        }
        if (printerName === null) {
            printerName = await this.findPrinterLegacy();
        }
        if (printerName === null) {
            throw "No printer found.";
        }
        console.log("Found printer: ", printerName);
        return printerName;
    }
    async findPluggedInPrinter() {
        let printers;
        try {
            printers = await qz.printers.find();
        } catch (e) {
            return null;
        }
        const filteredPrinters = printers.filter((p)=>{
            const printerName = p.toLowerCase();
            return PRINTERS.some((k)=>printerName.includes(k));
        });
        if (filteredPrinters.length === 0) {
            return null;
        }
        try {
            return await new Promise((resolve, reject)=>{
                const timer = setTimeout(()=>{
                    reject(new Error(`Could not find printer.`));
                }, 2000);
                qz.printers.startListening(filteredPrinters).then(()=>{
                    qz.printers.getStatus();
                    qz.printers.setPrinterCallbacks((event)=>{
                        if (event.statusText === "OK") {
                            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                            console.log(`Found connected printer: ${event.printerName}`);
                            clearTimeout(timer);
                            resolve(event.printerName);
                        }
                    });
                });
            });
        } catch (e) {
            // No printer found that is plugged in
            return null;
        }
    }
    async findPrinterLegacy() {
        console.log("Fallback to legacy printer search...");
        for (const printer of PRINTERS){
            try {
                const result = await qz.printers.find(printer);
                return Array.isArray(result) ? result[0] : result;
            } catch (e) {
            //
            }
        }
        console.error("Legacy printer search failed.");
        return null;
    }
    getPrinterConfigKey(orgId) {
        return `${PRINTER_CONFIG_PREFIX}${orgId}`;
    }
    constructor(url){
        this.url = "";
        this.url = url;
    }
}

const dateSchema = yup.mixed().nullable().transform((value, originalValue)=>{
    if (typeof originalValue === 'string') {
        return parseISO(originalValue);
    } else if (originalValue instanceof Date) {
        return originalValue;
    }
    return value;
});
function validateDate(date) {
    const castDate = dateSchema.cast(date);
    return isValid(castDate) ? castDate : undefined;
}
const toZonedDates = (timeZone, ...dates)=>{
    return dates.map((d)=>toZonedTime$1(d, timeZone));
};
const getDateFormatOptions = (dateStyle = "short", weekday)=>{
    return ({
        short: {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            weekday
        },
        medium: {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            weekday
        },
        long: {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            weekday
        },
        full: {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            weekday
        }
    })[dateStyle];
};
// Regex to convert AM/PM am/pm and "at"
const convertParts = (dateString)=>{
    return dateString.replace(/\s[APap][Mm]/g, (match)=>match.toLowerCase().trim()).replace(/\sat/g, ",");
};

const getLocalTimezone = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone;
function getTimezoneName(date, timezone, locale = "en") {
    const [, ...tzLong] = date.toLocaleTimeString(locale, {
        timeZoneName: "long",
        timeZone: timezone,
        hour12: false
    }).split(" ");
    const [, ...tzShort] = date.toLocaleTimeString(locale, {
        timeZoneName: "short",
        timeZone: timezone,
        hour12: false
    }).split(" ");
    const short = tzShort.join(" ");
    const long = tzLong.join(" ");
    const full = `${long} (${short})`;
    return {
        short,
        long,
        full
    };
}
const isSameDay = (startDate, endDate, timeZone)=>{
    if (!startDate || !endDate) return false;
    const [startInTZ, endInTZ] = toZonedDates(timeZone, startDate, endDate);
    return startInTZ.toDateString() === endInTZ.toDateString();
};
const isSameMonth = (startDate, endDate, timeZone)=>{
    if (!startDate || !endDate) return false;
    const [startInTZ, endInTZ] = toZonedDates(timeZone, startDate, endDate);
    return startInTZ.getMonth() === endInTZ.getMonth() && startInTZ.getFullYear() === endInTZ.getFullYear();
};
const isSameYear = (startDate, endDate, timeZone)=>{
    if (!startDate || !endDate) return false;
    const [startInTZ, endInTZ] = toZonedDates(timeZone, startDate, endDate);
    return startInTZ.getFullYear() === endInTZ.getFullYear();
};
function shiftUTCBetweenTimezones(dateInput, fromTz, toTz) {
    const zonedDateFrom = toZonedTime(dateInput, fromTz);
    return fromZonedTime(zonedDateFrom, toTz).toISOString();
}
function fromZonedTime(date, toTz) {
    return fromZonedTime$1(date, toTz);
}
function toZonedTime(date, fromTz) {
    return toZonedTime$1(date, fromTz);
}
function roundUpToNearest5Minutes(dateInput) {
    const date = validateDate(dateInput);
    if (!date) return;
    const coeff = 1000 * 60 * 5;
    return new Date(Math.ceil(date.getTime() / coeff) * coeff);
}
const validTimeFormat = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
/**
 * Converts a 24hr string into a 12hr string
 * 
 * @param time24 string in format HH:MM
 * @returns time in format HH:MMam/pm
 */ function convert24hrTo12HrTime(time24 = "") {
    if (!validTimeFormat.test(time24)) return "";
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? "pm" : "am";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes}${period}`;
}

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  convert24hrTo12HrTime: convert24hrTo12HrTime,
  fromZonedTime: fromZonedTime,
  getLocalTimezone: getLocalTimezone,
  getTimezoneName: getTimezoneName,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth,
  isSameYear: isSameYear,
  roundUpToNearest5Minutes: roundUpToNearest5Minutes,
  shiftUTCBetweenTimezones: shiftUTCBetweenTimezones,
  toZonedTime: toZonedTime
});

function formatDate(inputDate, type, options) {
    const date = validateDate(inputDate);
    // Soft fail
    if (!date) return "";
    const _ref = options || {}, { locale, timeZone, dateStyle = 'short', weekday, showStartTime = true, timeZoneName } = _ref, rest = _object_without_properties_loose(_ref, [
        "locale",
        "timeZone",
        "dateStyle",
        "weekday",
        "showStartTime",
        "timeZoneName"
    ]);
    const timeFormatter = new Intl.DateTimeFormat(locale, _extends({
        timeZone,
        hour: 'numeric',
        minute: 'numeric'
    }, rest));
    const formatOptions = getDateFormatOptions(dateStyle, weekday);
    const dateFormatter = new Intl.DateTimeFormat(locale, _extends({
        timeZone
    }, formatOptions, rest));
    let resultDateString;
    switch(type){
        case 'custom':
            resultDateString = new Intl.DateTimeFormat(locale, _extends({
                timeZone,
                weekday
            }, rest)).format(date);
            break;
        case 'time':
            resultDateString = timeFormatter.format(date);
            break;
        case 'date':
            resultDateString = dateFormatter.format(date);
            break;
        case 'datetime':
            if (!showStartTime) {
                resultDateString = dateFormatter.format(date);
            } else {
                resultDateString = `${dateFormatter.format(date)}, ${timeFormatter.format(date)}`;
            }
            break;
        default:
            throw new Error('Invalid format type');
    }
    resultDateString = convertParts(resultDateString);
    if (timeZoneName) {
        resultDateString = `${resultDateString} ${getTimezoneName(date, timeZone)[timeZoneName]}`;
    }
    return resultDateString;
}

function formatDateRange(inputDateStart, inputDateEnd, type, options) {
    const dateStart = validateDate(inputDateStart);
    const dateEnd = validateDate(inputDateEnd);
    // Soft fail
    if (!dateStart || !dateEnd) return "";
    const { locale, timeZone, dateStyle = 'short', weekday, showEndTime = true, showStartTime = true, timeZoneName } = options, rest = _object_without_properties_loose(options, [
        "locale",
        "timeZone",
        "dateStyle",
        "weekday",
        "showEndTime",
        "showStartTime",
        "timeZoneName"
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { timeZoneName: timeZoneNameNoop } = options, formatDateOptions = _object_without_properties_loose(options, [
        "timeZoneName"
    ]);
    let resultDateString = "";
    if (type === 'time') {
        const timeFormatter = new Intl.DateTimeFormat(locale, _extends({
            timeZone,
            hour: 'numeric',
            minute: 'numeric'
        }, rest));
        resultDateString = timeFormatter.formatRange(dateStart, dateEnd);
    } else if (type === 'date') {
        if (isSameDay(dateStart, dateEnd, timeZone)) {
            resultDateString = formatDate(dateStart, type, formatDateOptions);
        } else {
            const formatOptions = getDateFormatOptions(dateStyle, weekday);
            const dateFormatter = new Intl.DateTimeFormat(locale, _extends({
                timeZone
            }, formatOptions, rest));
            resultDateString = dateFormatter.formatRange(dateStart, dateEnd);
        }
    } else if (type === 'datetime') {
        const formatOptions = getDateFormatOptions(dateStyle, weekday);
        if (!showStartTime && !showEndTime) {
            if (isSameDay(dateStart, dateEnd, timeZone)) {
                resultDateString = formatDate(dateStart, "date", formatDateOptions);
            } else {
                // eslint-disable-next-line no-irregular-whitespace
                resultDateString = `${formatDate(dateStart, "date", formatDateOptions)} – ${formatDate(dateEnd, "date", formatDateOptions)}`;
            }
        } else if (!showEndTime || !showStartTime) {
            if (!showEndTime) {
                if (isSameDay(dateStart, dateEnd, timeZone)) {
                    resultDateString = formatDate(dateStart, showStartTime ? "datetime" : "date", formatDateOptions);
                } else {
                    // eslint-disable-next-line no-irregular-whitespace
                    resultDateString = `${formatDate(dateStart, "datetime", formatDateOptions)} – ${formatDate(dateEnd, "date", formatDateOptions)}`;
                }
            }
            if (!showStartTime) {
                if (isSameDay(dateStart, dateEnd, timeZone)) {
                    resultDateString = `${formatDate(dateStart, "date", formatDateOptions)}, Ends ${formatDate(dateEnd, "time", formatDateOptions)}`;
                } else {
                    // eslint-disable-next-line no-irregular-whitespace
                    resultDateString = `${formatDate(dateStart, "date", formatDateOptions)} – ${formatDate(dateEnd, "datetime", _extends({}, formatDateOptions, {
                        showStartTime: true
                    }))}`;
                }
            }
        } else {
            const dateFormatter = new Intl.DateTimeFormat(locale, _extends({
                timeZone,
                hour: 'numeric',
                minute: 'numeric'
            }, formatOptions, rest));
            resultDateString = dateFormatter.formatRange(dateStart, dateEnd);
        }
    } else {
        throw new Error('Invalid format type');
    }
    resultDateString = convertParts(resultDateString);
    if (timeZoneName) {
        resultDateString = `${resultDateString} ${getTimezoneName(dateStart, timeZone)[timeZoneName]}`;
    }
    return resultDateString;
}

function formatEventDateRange(inputDateStart, inputDateEnd, options) {
    const dateStart = validateDate(inputDateStart);
    const dateEnd = validateDate(inputDateEnd);
    // Soft fail
    if (!dateStart || !dateEnd) return "";
    const { format, showEndTime = true } = options;
    switch(format){
        case 'basicShort':
            if (isSameDay(dateStart, dateEnd, options.timeZone)) {
                return formatDate(dateStart, "datetime", _extends({}, options, {
                    dateStyle: 'short',
                    weekday: 'short'
                }));
            }
            return formatDateRange(dateStart, dateEnd, "date", _extends({}, options, {
                dateStyle: 'short',
                weekday: 'short'
            }));
        case 'basicLong':
            if (isSameDay(dateStart, dateEnd, options.timeZone)) {
                return formatDate(dateStart, "datetime", _extends({}, options, {
                    dateStyle: 'long',
                    weekday: 'long'
                }));
            }
            return formatDateRange(dateStart, dateEnd, "date", _extends({}, options, {
                showEndTime,
                dateStyle: 'long',
                weekday: 'long'
            }));
        case 'detailedShort':
            return formatDateRange(dateStart, dateEnd, "datetime", _extends({}, options, {
                showEndTime,
                dateStyle: 'short',
                weekday: 'short'
            }));
        case 'detailedLong':
            return formatDateRange(dateStart, dateEnd, "datetime", _extends({}, options, {
                showEndTime,
                dateStyle: 'long',
                weekday: 'long'
            }));
    }
}

const ZonedDate = {
    format: formatDate,
    formatRange: formatDateRange,
    formatEventRange: formatEventDateRange,
    utils
};

// This is by no means an exhaustive list of countries and currencies.
// However, it is the list of countries and currencies currently supported by
// Stripe, which should cover the majority of our use cases.
const currencyData = {
    AFN: {
        currencySymbol: "؋",
        currencyCode: "AFN",
        alpha2Code: "AF",
        locales: [
            "fa-AF"
        ]
    },
    ALL: {
        currencySymbol: "L",
        currencyCode: "ALL",
        alpha2Code: "AL",
        locales: [
            "sq-AL"
        ]
    },
    DZD: {
        currencySymbol: "د.ج",
        currencyCode: "DZD",
        alpha2Code: "DZ",
        locales: [
            "ar-DZ"
        ]
    },
    EUR: {
        currencySymbol: "€",
        currencyCode: "EUR",
        alpha2Code: "EU",
        locales: [
            "fr-FR",
            "de-DE",
            "es-ES",
            "it-IT",
            "nl-NL",
            "pt-PT",
            "fi-FI",
            "et-EE"
        ]
    },
    AOA: {
        currencySymbol: "Kz",
        currencyCode: "AOA",
        alpha2Code: "AO",
        locales: [
            "pt-AO"
        ]
    },
    ARS: {
        currencySymbol: "$",
        currencyCode: "ARS",
        alpha2Code: "AR",
        locales: [
            "es-AR"
        ]
    },
    AMD: {
        currencySymbol: "֏",
        currencyCode: "ARM",
        alpha2Code: "AM",
        locales: [
            "hy-AM"
        ]
    },
    AUD: {
        currencySymbol: "$",
        currencyCode: "AUD",
        alpha2Code: "AU",
        locales: [
            "en-AU"
        ]
    },
    AZN: {
        currencySymbol: "₼",
        currencyCode: "AZE",
        alpha2Code: "AZ",
        locales: [
            "az-AZ"
        ]
    },
    BRL: {
        currencySymbol: "R$",
        currencyCode: "BRL",
        alpha2Code: "BR",
        locales: [
            "pt-BR"
        ]
    },
    BMD: {
        currencySymbol: "$",
        currencyCode: "BMD",
        alpha2Code: "BM",
        locales: [
            "en-BM"
        ]
    },
    BSD: {
        currencySymbol: "$",
        currencyCode: "BHD",
        alpha2Code: "BS",
        locales: [
            "en-BS"
        ]
    },
    BHD: {
        currencySymbol: "د.ب",
        currencyCode: "BHD",
        alpha2Code: "BH",
        locales: [
            "ar-BH"
        ]
    },
    BDT: {
        currencySymbol: "৳",
        currencyCode: "BDT",
        alpha2Code: "BD",
        locales: [
            "bn-BD"
        ]
    },
    CAD: {
        currencySymbol: "$",
        currencyCode: "CAD",
        alpha2Code: "CA",
        locales: [
            "en-CA",
            "fr-CA"
        ]
    },
    CHF: {
        currencySymbol: "CHF",
        currencyCode: "CHF",
        alpha2Code: "CH",
        locales: [
            "de-CH",
            "fr-CH",
            "it-CH"
        ]
    },
    CNY: {
        currencySymbol: "¥",
        currencyCode: "CNY",
        alpha2Code: "CN",
        locales: [
            "zh-CN"
        ]
    },
    GBP: {
        currencySymbol: "£",
        currencyCode: "GBP",
        alpha2Code: "GB",
        locales: [
            "en-GB"
        ]
    },
    INR: {
        currencySymbol: "₹",
        currencyCode: "INR",
        alpha2Code: "IN",
        locales: [
            "hi-IN",
            "en-IN"
        ]
    },
    JPY: {
        currencySymbol: "¥",
        currencyCode: "JPY",
        alpha2Code: "JP",
        locales: [
            "ja-JP"
        ]
    },
    KRW: {
        currencySymbol: "₩",
        currencyCode: "KRW",
        alpha2Code: "KR",
        locales: [
            "ko-KR"
        ]
    },
    MXN: {
        currencySymbol: "$",
        currencyCode: "MXN",
        alpha2Code: "MX",
        locales: [
            "es-MX"
        ]
    },
    NZD: {
        currencySymbol: "$",
        currencyCode: "NZD",
        alpha2Code: "NZ",
        locales: [
            "en-NZ"
        ]
    },
    RUB: {
        currencySymbol: "₽",
        currencyCode: "RUB",
        alpha2Code: "RU",
        locales: [
            "ru-RU"
        ]
    },
    THB: {
        currencySymbol: "฿",
        currencyCode: "THB",
        alpha2Code: "TH",
        locales: [
            "th-TH"
        ]
    },
    USD: {
        currencySymbol: "$",
        currencyCode: "USD",
        alpha2Code: "US",
        locales: [
            "en-US",
            "es-US"
        ]
    }
};
const getI18nCurrency = (currencyCode, fallback = "NZD")=>{
    var _currencyData_currencyCode;
    return (_currencyData_currencyCode = currencyData[currencyCode]) != null ? _currencyData_currencyCode : currencyData[fallback];
};

/**
 * Formats a price as a currency string.
 * @param price - The numeric price value to format.
 * @param options - Formatting options.
 * @param options.currency - The ISO4217 currency code (e.g., 'NZD').
 */ const formatPrice = (price, options)=>{
    const { currency } = options;
    const currencyData = getI18nCurrency(currency);
    // Get browser's preferred locales for formatting
    let userLocales = [
        "en-NZ"
    ];
    if (typeof window !== "undefined" && window.navigator) {
        var _window_navigator_languages;
        userLocales = (_window_navigator_languages = window.navigator.languages) != null ? _window_navigator_languages : [
            window.navigator.language
        ];
    }
    var _currencyData_locales_find;
    // Find the best matching locale,
    // defaulting to the first locale if the users browser doesn't
    // match any of the currency's locales, so it is always
    // formatted in the intended locale of the currency.
    const matchedLocale = (_currencyData_locales_find = currencyData.locales.find((locale)=>userLocales.some((userLocale)=>userLocale.toLowerCase().startsWith(locale.toLowerCase().split("-")[0])))) != null ? _currencyData_locales_find : currencyData.locales[0];
    return new Intl.NumberFormat(matchedLocale, {
        style: "currency",
        currency: currencyData.currencyCode
    }).format(price);
};

function countSmsCodePoints(message) {
    const gsm7BitCharacters = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\x1BÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
    const gsm7BitExtendedCharacters = "{}[]~^\\|€";
    let gsm7BitCount = 0;
    for(let i = 0; i < message.length; i++){
        const char = message[i];
        if (gsm7BitCharacters.includes(char)) {
            gsm7BitCount++;
        } else if (gsm7BitExtendedCharacters.includes(char)) {
            gsm7BitCount += 2; // extended characters count as 2
        } else {
            // If the character is not in the GSM 7-bit set, it's UTF-8.
            return {
                encoding: "UTF-8",
                codePointCount: new TextEncoder().encode(message).length
            };
        }
    }
    return {
        encoding: "GSM-7",
        codePointCount: gsm7BitCount
    };
}
function calculateNumGsmSmsMessages(text) {
    // A single SMS message can contain up to 160 characters.
    const singleMessageLimit = 160;
    // A multi-part SMS message contains up to 153 characters per part.
    const multiMessageLimit = 153;
    const { codePointCount, encoding } = countSmsCodePoints(text);
    if (encoding !== "GSM-7") {
        throw new Error("Only GSM 7-bit characters are supported.");
    }
    if (codePointCount <= singleMessageLimit) {
        return 1;
    } else {
        return Math.ceil(codePointCount / multiMessageLimit);
    }
}

const useI18nCurrency = (currency)=>{
    return getI18nCurrency(currency);
};

export { Printer, ZonedDate, arrayConstToMap, calculateNumGsmSmsMessages, convertToPlainText, convertToRichText, countSmsCodePoints, ensurePlainTextFormat, ensureRichTextFormat, formatPrice, hasRichTextContent, isRichTextOnlyParagraphs, isValidRichTextFormat, parseAsRichText, printerConfigDefault, sum, test, useI18nCurrency, validateRichText };
